
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getOverridesMap = function getOverridesMap(overrideParam) {
  var overridesMap = [];
  overrideParam.split(',').forEach(function (overrideStr) {
    var splits = overrideStr.split('=');
    overridesMap[splits[0]] = splits[1];
  });
  return overridesMap;
};

/* eslint-disable santa/no-starts-with */
var isScriptValid = function isScriptValid(url, scriptsLocation) {
  return url.startsWith(scriptsLocation) || url.startsWith('https://localhost') || url.startsWith('http://localhost');
};

var overrideViewerScripts = function overrideViewerScripts(clientSpecMap, overrideParam, scriptsLocation) {
  if (!overrideParam) {
    return;
  }

  var overridesMap = getOverridesMap(overrideParam);

  Object.keys(clientSpecMap).forEach(function (applicationId) {
    var applicationSpec = clientSpecMap[applicationId];
    var overridenScript = overridesMap[applicationSpec.appDefinitionId];

    if (overridenScript && isScriptValid(overridenScript, scriptsLocation) && applicationSpec.appFields && applicationSpec.appFields.platform && applicationSpec.appFields.platform.viewerScriptUrl) {
      applicationSpec.appFields.platform.viewerScriptUrl = overridenScript;
    }
  });
};

var overrideWidgetScripts = function overrideWidgetScripts(clientSpecMap, overrideParam, scriptKeyName, scriptsLocation) {
  if (!overrideParam) {
    return;
  }

  var overridesMap = getOverridesMap(overrideParam);

  Object.keys(clientSpecMap).forEach(function (applicationId) {
    var applicationWidgets = clientSpecMap[applicationId].widgets || {};
    Object.keys(applicationWidgets).forEach(function (widgetId) {
      var urlOverride = overridesMap[widgetId];

      if (urlOverride && isScriptValid(urlOverride, scriptsLocation) && applicationWidgets[widgetId].componentFields) {
        var componentFields = applicationWidgets[widgetId].componentFields;
        componentFields[scriptKeyName] = componentFields[scriptKeyName] || '';
        componentFields[scriptKeyName] = urlOverride;
      }
    });
  });
};

var mergeOverrideScriptsInClientSpecMap = function mergeOverrideScriptsInClientSpecMap(clientSpecMap) {
  var viewerScriptOverrideParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var controllerScriptsOverrideParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var componentScriptsOverrideParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var scriptsLocation = arguments[4];

  overrideViewerScripts(clientSpecMap, viewerScriptOverrideParam, scriptsLocation);
  overrideWidgetScripts(clientSpecMap, controllerScriptsOverrideParam, 'controllerUrl', scriptsLocation);
  overrideWidgetScripts(clientSpecMap, componentScriptsOverrideParam, 'componentUrl', scriptsLocation);
};

exports.default = mergeOverrideScriptsInClientSpecMap;
//# sourceMappingURL=overrideClientSpecMapScriptsFromQuery.js.map